import { defineMessages } from 'react-intl';

export default defineMessages({
    duplicateCustomerLookup: {
        id: 'ml.gateway.common.possibleAccountsModal.existingCustomersHeader',
        defaultMessage: 'We found {numberOfExistingCustomers} existing customers similar to {customerName}'
    },
    existingCustomersHeader: {
        id: 'ml.gateway.common.possibleAccountsModal.Duplicate Customer Lookup',
        defaultMessage: 'Duplicate Customer Lookup'
    },
    addNewCustomerButton: {
        id: 'ml.gateway.common.possibleAccountsModal.ADD NEW CUSTOMER',
        defaultMessage: 'ADD NEW CUSTOMER'
    },
    numberOfProductsAuto: {
        id: 'ml.gateway.common.possibleAccountsModal.numberOfProductsAuto',
        defaultMessage: 'Auto ({numberOfProducts})'
    },
    numberOfProductsHome: {
        id: 'ml.gateway.common.possibleAccountsModal.numberOfProductsHome',
        defaultMessage: 'Home ({numberOfProducts})'
    },
    numberOfProductUmbrella: {
        id: 'ml.gateway.common.possibleAccountsModal.numberOfProductsUmbrella',
        defaultMessage: 'Umbrella ({numberOfProducts})'
    },
    accountAddress: {
        id: 'ml.gateway.common.possibleAccountsModal.ADDRESS',
        defaultMessage: 'ADDRESS'
    },
    accountPhone: {
        id: 'ml.gateway.common.possibleAccountsModal.PHONE',
        defaultMessage: 'PHONE'
    },
    selectButton: {
        id: 'ml.gateway.common.possibleAccountsModal.SELECT',
        defaultMessage: 'SELECT'
    },
    productsHeader: {
        id: 'ml.gateway.common.possibleAccountsModal.PRODUCTS',
        defaultMessage: 'PRODUCTS'
    },
    noneAreMatch: {
        id: 'ml.gateway.common.possibleAccountsModal.None of these are a match',
        defaultMessage: 'None of these are a match'
    }
});